
(function() {
    'use strict';
    
a3_cabin_reports.controller('SearchPastGDCtrl', SearchPastGDCtrl);
    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name SearchPastGDCtrl
    * @description 
    *   Search pending duties 
    * @ngInject
    */ 
function SearchPastGDCtrl($scope, GroundDutyFactory, PastDutyFactory, $uibModalInstance, $route, CourseFactory, defaultCalendarDate, CrewRouteFactory, FlightFactory) {			
		$scope.dutyId = null;
		$scope.showContent = 'search';
		$scope.course = {
			isCourseLimited : true
		}
		$scope.hasError = false;

		// cancel
		$scope.doCancel =  doCancel;

		$scope.closeModal = closeModal;

		$scope.showMessage = true;

		var today = new Date().toUTC();
        if (defaultCalendarDate) {
            today = new Date(defaultCalendarDate).toUTC();
        }

        $scope.dutyDatePicker = {
            value: today,
            format: 'dd-MM-yyyy',
            opened: false
        }
	
        $scope.dateFormat = 'dd-MM-yyyy';

        $scope.openDatepicker = openDatepicker;

        function openDatepicker() {
            $scope.dutyDatePicker.opened = true;
        }

        $scope.searchGDByDate = searchGDByDate;	
        $scope.searchNotStarted = searchNotStarted;	

        function searchGDByDate() {
			$scope.hasError = false;
			$scope.showContent = 'loading';
			PastDutyFactory.getPastDuties($scope.dutyDatePicker.value.toString('yyyy-MM-dd')) 
				.then(res => handleSubmitResponse(res))
                .catch(res => handleFailedResponse(res));
		}

        function searchNotStarted() {
			$scope.hasError = false;
			$scope.showContent = 'loading';
			PastDutyFactory.getNotStartedDuties($scope.dutyDatePicker.value.toString('yyyy-MM-dd')) 
				.then(res => handleNotStartedSubmitResponse(res))
                .catch(res => handleNotStartedFailedResponse(res));
		}


		// search pending gd
		$scope.searchGD = searchGD;	

        /**
         * Close the modal
         * @memberof SearchPastGDCtrl
         */
        function doCancel() {
			$uibModalInstance.close('cancel');
		}  

		function searchGD() {			
			$scope.showContent = 'loading';
			PastDutyFactory.getPastDuties('')  
				.then(res => handleSubmitResponse(res))
                .catch(res => handleFailedResponse(res));
		}
			
		function handleSubmitResponse(res) {
			$scope.showContent = 'results';

			$scope.availableCources = res.data.trainingCourses;
            $scope.pendingDuties = res.data.pendingGroundDuties;
            $scope.flightTrainings = res.data.pendingRoutes;
            $scope.pendingFlightCourses = res.data.flightCourses;
            
            var flights = res.data.flightsForPendingRoutes;
            FlightFactory.insertFlightsWithPendingTrainings(flights);

            $scope.availableCources.forEach(function(course) {
                course.HasLimitedInfo = true;
                CourseFactory.upsertCourse(course, function() { });
            });
            $scope.pendingDuties.forEach(function(duty) {
                duty.isManualEntry = true;
                duty.hasPendingCourse = true;
                GroundDutyFactory.addGroundDuty(duty);
            });
            $scope.flightTrainings.forEach(function(pendingRoute){
                pendingRoute.isManualEntry = true;
                pendingRoute.hasPendingCourse = true;
                CrewRouteFactory.addCrewRouteDuty(pendingRoute);
            });
            $scope.pendingFlightCourses.forEach(function(course) {
                course.HasLimitedInfo = true;
                CourseFactory.upsertCourse(course, function() { });
            });
        }

        function handleNotStartedSubmitResponse(res) {
			$scope.showContent = 'notStartedResults';

			$scope.notStartedGroundDuties = res.data.notStartedGroundDuties;        
            $scope.groundCourses = res.data.trainingCourses;

            $scope.notStartedGroundDuties.forEach(function(duty) {
                duty.isManualEntry = true;
                duty.hasPendingCourse = true;
                GroundDutyFactory.addGroundDuty(duty);
            });   
            $scope.groundCourses.forEach(function(course) {
                course.HasLimitedInfo = true;
                CourseFactory.upsertCourse(course, function() { });
            }); 
        }

		function closeModal() {
			$uibModalInstance.close();
			$route.reload();
		}

		function handleFailedResponse(res) {
            $scope.showContent = 'results';
			$scope.hasError = true;
        }	
        
        function handleNotStartedFailedResponse(res) {
            $scope.showContent = 'notStartedResults';
			$scope.hasError = true;
        }	
	}

})();